import { render, staticRenderFns } from "./office.vue?vue&type=template&id=2e5471a6&scoped=true&lang=pug"
import script from "./office.vue?vue&type=script&lang=js"
export * from "./office.vue?vue&type=script&lang=js"
import style0 from "./office.vue?vue&type=style&index=0&id=2e5471a6&prod&rel=stylesheet%2Fscss&lang=scss"
import style1 from "./office.vue?vue&type=style&index=1&id=2e5471a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5471a6",
  null
  
)

export default component.exports